module.exports = __webpack_public_path__ + "img/symbol_4.2da818ef.png";